import React from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const MediaNavigation = ({ currentIndex, totalItems, onPrevious, onNext, isDarkMode }) => {
  if (totalItems <= 1) return null;
  
  const themeClass = isDarkMode ? 'dark' : 'light';
  
  return (
    <>
      {/* No arrow toward a file that does not exist: hidden on the first and last item
          (swipe and arrow keys still bounce at the ends). */}
      {currentIndex > 0 && (
        <button
          className={`nav-button prev-button ${themeClass}`}
          onClick={onPrevious}
          aria-label="Previous item"
        >
          <LeftOutlined />
        </button>
      )}

      {currentIndex < totalItems - 1 && (
        <button
          className={`nav-button next-button ${themeClass}`}
          onClick={onNext}
          aria-label="Next item"
        >
          <RightOutlined />
        </button>
      )}
      
      <div className={`media-counter ${themeClass}`}>
        {currentIndex + 1} / {totalItems}
      </div>
    </>
  );
};

export default MediaNavigation;
